<template>
    <div class="navbar">
        <button @click="toggleTheme" class="theme-toggle-btn">
            <Sun :size="20" v-if="isDark" />
            <MoonStar :size="20" v-if="!isDark" />
        </button>
    </div>
</template>

<script>
import { theme, setTheme } from '../../../../utils/theme'
import { MoonStar, Sun } from 'lucide-vue'

export default {
    computed: {
        themeMode() {
            return theme.mode
        },
        isDark() {
            return this.themeMode === 'dark'
        },
    },
    mounted() {
        // S'assurer que Vuetify est synchronisé au démarrage
        if (this.$vuetify) {
            this.$vuetify.theme.dark = this.isDark
        }
    },
    methods: {
        toggleTheme() {
            const newMode = this.isDark ? 'light' : 'dark'
            setTheme(newMode)
            if (this.$vuetify) {
                this.$vuetify.theme.dark = newMode === 'dark'
            }
        },
    },
    components: {
        MoonStar,
        Sun,
    },
}
</script>

<style scoped>
.navbar {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
}
button {
    cursor: pointer;
    background: transparent;
    border: none;
    font-size: 1.2em;
    color: white;
}
</style>
